module.exports = __webpack_public_path__ + "static/img/91logo_lightblue.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/91logo_lightblue.png
// module id = DZ4N
// module chunks = 0